import * as React from 'react';
import { useNavigate, useLocation } from 'react-router';
import { isAuthenticated } from 'utils/auth';

type ProtectedRouteProps = {
  children: React.ReactNode;
};

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  React.useEffect(() => {
    if (!isAuthenticated()) {
      const pageToRedirectTo = `${location.pathname}${location.search ?? ''}`;
      navigate('/auth', { state: { page: pageToRedirectTo } });
    }
  });

  return isAuthenticated() ? children : null;
};

export default ProtectedRoute;
